// extracted by mini-css-extract-plugin
export default {"wrapper":"StatusPage_wrapper__fmZTO","wrapper_header":"StatusPage_wrapper_header__XKGUS","wrapper_tabs":"StatusPage_wrapper_tabs__P6Ju6"};